<template>
  <div class="delivery-bill d-flex flex-center">
    <div class="print-2023" v-if="listScore.data_info">
      <div class="name-wrap d-flex justify-content-between">
        <div class="name-school d-flex flex-column align-items-center">
          <span>{{ listScore.data_info.school_description }}</span>
          <span>{{ listScore.data_info.school_text }}</span>
          <div class="line-09991"></div>
        </div>
        <div class="name-vn">
          <div class="name_vn_son">
            <span class="text-1">Cộng hòa xã hội chủ nghĩa Việt Nam</span>
            <span class="text-2">Độc lập - Tự do - Hạnh phúc</span>
            <span class="line-0999"></span>
          </div>
        </div>
      </div>
      <div class="main-title-999 d-flex justify-content-center">
        <span v-if="listScore.data_info.school_text.toLowerCase().includes('cao đẳng')">Bảng điểm toàn khoá</span>
        <span v-if="listScore.data_info.school_text.toLowerCase().includes('trung cấp')">Bảng điểm ghi kết quả học tập</span>
      </div>
      <div class="main-info">
        <el-row :gutter="20">
          <el-col :span="12">
            <div>
              <div class="item-90">
                <span class="title">Họ và tên học viên</span>
                <span class="data">: {{ listScore.data_info.user_name }}</span>
              </div>
              <div class="item-90">
                <span class="title">Giới tính</span>
                <span class="data">: {{ listScore.data_info.sex }}</span>
              </div>
              <div class="item-90">
                <span class="title">Ngày sinh</span>
                <span class="data">: {{ listScore.data_info.user_birtday }}</span>
              </div>
              <div class="item-90">
                <span class="title">Nơi sinh</span>
                <span class="data">: {{ listScore.data_info.user_address }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <div class="item-90">
                <span class="title">Khóa học</span>
                <span class="data">: {{ listScore.data_info.class_pro_year }}</span>
              </div>
              <div class="item-90">
                <span class="title">Trình độ đào tạo</span>
                <span class="data">: {{ schoolLevel(listScore.data_info.level_text, listScore.data_info.school_text) }}</span>
              </div>
              <div class="item-90">
                <span class="title">Hệ đào tạo</span>
                <span class="data">: {{ trainingSystem(listScore.data_info.level_text) }}</span>
              </div>
              <div class="item-90">
                <span class="title">Ngành</span>
                <span class="data">: {{ listScore.data_info.facult_text }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="table-common">
              <table>
                <tr>
                  <th width="40" rowspan="2">STT</th>
                  <th rowspan="2">Tên môn học,<br>mô đun</th>
                  <th width="40" rowspan="2">Số<br>TC</th>
                  <th width="60" colspan="3">Điểm</th>

                  <th width="40" rowspan="2">STT</th>
                  <th rowspan="2">Tên môn học,<br>mô đun</th>
                  <th width="40" rowspan="2">Số<br>TC</th>
                  <th width="60" colspan="3">Điểm</th>
                </tr>
                <tr>
                  <th width="30">T10</th>
                  <th width="40">Chữ</th>
                  <th width="30">T4</th>
                  <th width="30">T10</th>
                  <th width="40">Chữ</th>
                  <th width="30">T4</th>
                </tr>

                <!-- content -->
                <tr v-for="(item, i) in listScore.allObjects" :key="i">
                  <template v-if="i < getNumberOfObject">
                    <template v-if="listScore.allObjects[i]">
                      <td>{{ i + 1 }}</td>
                      <td class="text-left" style="width: 300px;">{{ listScore.allObjects[i].course_name }}</td>
                      <td>{{ listScore.allObjects[i].course_redit }}</td>
                      <td>{{ formatPoint(listScore.allObjects[i].dtbm) }}</td>
                      <td>{{ exchangeLetterPoint(listScore.allObjects[i].dtbm) }}</td>
                      <td>{{ exchangeFourPoint(listScore.allObjects[i].dtbm) }}</td>
                    </template>
                    <template v-if="listScore.allObjects[getNumberOfObject + i]">
                      <td>{{ getNumberOfObject + i + 1 }}</td>
                      <td class="text-left" style="width: 300px;">{{ listScore.allObjects[getNumberOfObject + i].course_name }}</td>
                      <td>{{ listScore.allObjects[getNumberOfObject + i].course_redit }}</td>
                      <td>{{ formatPoint(listScore.allObjects[getNumberOfObject + i].dtbm) }}</td>
                      <td>{{ exchangeLetterPoint(listScore.allObjects[getNumberOfObject + i].dtbm) }}</td>
                      <td>{{ exchangeFourPoint(listScore.allObjects[getNumberOfObject + i].dtbm) }}</td>
                    </template>
                    <template v-else>
                      <td>{{ getNumberOfObject + i + 1 }}</td>
                      <td class="text-left" style="width: 300px;"></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </template>
                  </template>

                </tr>
                <!-- end content -->
              </table>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- trung cấp edit -->
      <template v-if="listScore.data_info.school_text.toLowerCase().includes('trung cấp')">
        <div class="total-score">
          <el-row :gutter="20">
            <el-row :span="24" class="mt-4 mb-2"><span class="text-1 ml-2 text-uppercase">Điểm thi tốt
                nghiệp</span></el-row>
            <el-col :span="12">
              <table class="no-border" cellspacing="0" cellpadding="0">
                <tr v-for="(item, key) in tableV3" :key="key">
                  <td class="huhu text-nowrap-mod">- {{ item.course_name }}</td>
                  <td>:</td>
                  <td width="50">{{ item.dtbm }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">- Điểm trung bình Theo thang điểm 10</td>
                  <td>:</td>
                  <td width="50">{{ listScore.tdb_all_avg }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">- Điểm trung bình Theo thang điểm 4</td>
                  <td>:</td>
                  <td width="50">{{ exchangeFourPoint(listScore.tdb_all_avg) }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">- Xếp loại tốt nghiệp</td>
                  <td>:</td>
                  <td width="50"><span style="font-weight: bold;">{{ listScore.rating }}</span></td>
                </tr>
                <tr>
                  <td colspan="3"><i>(<strong>Ghi chú:</strong> Bảng điểm chỉ cấp một lần, không cấp lại)</i>
                  </td>
                </tr>
              </table>
            </el-col>
            <el-col :span="12">
              <div class="sign-19231">
                <div class="d-flex flex-column align-items-center">
                  <span class="addresss">{{ listScore.data_info.school_address }}, ngày {{ listScore.date_info.data_day }}
                    tháng {{ listScore.date_info.data_month }} năm {{ listScore.date_info.data_year }}</span>
                  <span class="name">KT. Hiệu Trưởng </span>
                  <span class="name">Phó hiệu trưởng</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!-- end trung cấp edit -->

      <!-- cao đẳng -->
      <template v-if="listScore.data_info.school_text.toLowerCase().includes('cao đẳng')">
        <div class="mt-4">
          <el-row :gutter="20">
            <el-col :span="12">
              <table class="no-border" width="325" cellspacing="0" cellpadding="0">
                <tr v-if="existThematic">
                  <td class="huhu text-nowrap-mod" style="width: 200px;">Xếp loại chuyên đề 1</td>
                  <td>:</td>
                  <td width="50">{{ thematic1 }}</td>
                </tr>
                <tr v-if="existThematic">
                  <td class="huhu text-nowrap-mod" style="width: 200px;">Xếp loại chuyên đề 2</td>
                  <td>:</td>
                  <td width="50">{{ thematic2 }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">Điểm trung bình Theo thang điểm 10</td>
                  <td>:</td>
                  <td width="50">{{ listScore.tdb_all_avg }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">Điểm trung bình theo thang điểm 4</td>
                  <td>:</td>
                  <td width="50">{{ exchangeFourPoint(listScore.tdb_all_avg) }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">Xếp loại tốt nghiệp</td>
                  <td>:</td>
                  <td width="50"><span style="font-weight: bold;">{{ listScore.rating }}</span></td>
                </tr>
                <tr>
                  <td colspan="3"><i>(<strong>Ghi chú:</strong> Bảng điểm chỉ cấp một lần, không cấp lại)</i>
                  </td>
                </tr>
              </table>
            </el-col>
            <el-col :span="12">
              <div class="sign-19231">
                <div class="d-flex flex-column align-items-center">
                  <span class="addresss">{{ listScore.data_info.school_address }}, ngày {{ listScore.date_info.data_day }}
                    tháng {{ listScore.date_info.data_month }} năm {{ listScore.date_info.data_year }}</span>
                  <span class="name">KT. Hiệu Trưởng </span>
                  <span class="name">Phó hiệu trưởng</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!-- cao đẳng -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
// eslint-disable-next-line no-unused-vars
import apiMock from '../../api/mock3.json'
import _, {head} from 'lodash'
export default {
  name: 'ShowPrint',
  metaInfo () {
    return {
      title: 'Lớp học'
    }
  },
  data () {
    return {
      loading: false,
      canSubmit: true,
      modelData: {},
      listScore: [],

      // Xem
      dialogVisible: false,
      modelScore: {},

      // Lop:
      modelDataClassPro: {},

      tableV1: [
        { name: 'Giáo dục quốc phòng', credit: 2, score: 7.3 },
        { name: 'Chính trị', credit: 3, score: 7.3 },
        { name: 'Giáo dục thể chất', credit: 4, score: 7.3 },
        { name: 'Ngoại ngữ', credit: 4, score: 7.3 },
        { name: 'Pháp luật', credit: 4, score: 7.3 },
        { name: 'Văn học', credit: 4, score: 7.3 },
        { name: 'Tiếng Việt', credit: 4, score: 7.3 },
        { name: 'Toán cơ bản', credit: 4, score: 7.3 },
        { name: 'Giáo dục tiểu học', credit: 4, score: 7.3 },
        { name: 'Tâm lý tiểu học', credit: 4, score: 7.3 }
      ],
      tableV3: [
        // { name: 'Chính trị', dtbm: 7.0, course_redit:  2},
        // { name: 'Lý thuyết tổng hợp', dtbm: 8.3, course_redit:  2 },
        // { name: 'Thực hành nghề nghiệp', dtbm: 7.3, course_redit:  2 },
        {
          'booking_id': 37244,
          'course_code': 'DC001',
          'course_hide': false,
          'course_id': 3063,
          'course_logic': 1,
          'course_name': 'Chính trị',
          'course_position': 1,
          'course_redit': 2,
          'course_term': 1,
          'dtbm': 7.0,
          'score_attendance': 8,
          'text_result': null,
          'type1': null,
          'type12': null,
          'type14': ''
        },
        {
          'booking_id': 37244,
          'course_code': 'DC001',
          'course_hide': false,
          'course_id': 3063,
          'course_logic': 1,
          'course_name': 'Lý thuyết tổng hợp',
          'course_position': 1,
          'course_redit': 2,
          'course_term': 1,
          'dtbm': 8.3,
          'score_attendance': 8,
          'text_result': null,
          'type1': null,
          'type12': null,
          'type14': ''
        },
        {
          'booking_id': 37244,
          'course_code': 'DC001',
          'course_hide': false,
          'course_id': 3063,
          'course_logic': 1,
          'course_name': 'Thực hành nghề nghiệp',
          'course_position': 1,
          'course_redit': 2,
          'course_term': 1,
          'dtbm': 8.3,
          'score_attendance': 8,
          'text_result': null,
          'type1': null,
          'type12': null,
          'type14': ''
        }
      ]
    }
  },
  mounted () {
    // this.fetchModelClassPro()
    // this.fetchModel()
    this.fetchDatabaseModel()
    setTimeout(() => {
      this.inBill()
    }, 1500)
  },
  computed: {
    getNumberOfObject () {
      return Math.ceil((this.listScore.allObjects.length) / 2)
    },
    existThematic () {
      let thematic = this.listScore.allObjects.filter(item => item.course_name.toLowerCase().includes('chuyên đề'))
      if (thematic.length > 0) {
        return true
      }
      return false
    },
    thematic1 () {
      if (this.existThematic) {
        let point = this.listScore.allObjects.filter(item => item.course_name.toLowerCase().includes('chuyên đề 1'))
        let thematicPoint1 = point.slice(-1).pop().dtbm
        return this.exchangeAppellation(thematicPoint1)
      }
      return ''
    },
    thematic2 () {
      if (this.existThematic) {
        let point = this.listScore.allObjects.filter(item => item.course_name.toLowerCase().includes('chuyên đề 2'))
        let thematicPoint2 = point.slice(-1).pop().dtbm
        return this.exchangeAppellation(thematicPoint2)
      }
      return ''
    }

  },
  methods: {
    inBill () {
      window.print()
    },
    returnTitle (index) {
      if (index === 0) return 'A.'
      if (index === 1) return 'B.'
      if (index === 2) return 'C.'
      if (index === 3) return 'D.'
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' },
        { name: 'class-pros-show-list-user', id: this.$route.params.id, text: 'Lớp: ' + this.modelDataClassPro.code },
        { name: 'class-pros-update1', text: 'Xem kết quả thi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({ name: 'class-pros-show', params: { id: this.$route.params.id } })
    },
    // Tải dữ liệu Model xuống
    fetchModelClassPro () {
      this.canSubmit = false
      axios.get('class-pros/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelDataClassPro = response.data
            this.configBreadcrumb()
            setTimeout(() => {
              this.inBill()
            }, 1500)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('class-users/' + this.$route.params.id_class_user).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchDatabaseModel () {
      this.loading = true
      axios.post('class-users/view-print-v2/' + this.$route.params.id_class_user).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.listScore = response.data
            let hocky1 = []
            let hocky2 = []
            if (response.data.hasOwnProperty('arr_1')) {
              hocky1 = response.data.arr_1
            }
            if (response.data.hasOwnProperty('arr_2')) {
              hocky2 = response.data.arr_2
            }
            this.listScore.allObjects = _.concat(hocky1, hocky2)
            break
          case 404:
            break
          default:
            break
        }
      })
    },
    showScore (model, type) {
      this.dialogVisible = true
      let id
      if (type === 'type1') {
        id = model.type1_test_result_id
      }
      if (type === 'type12') {
        id = model.type12_test_result_id
      }
      if (type === 'type14') {
        id = model.type14_test_result_id
      }
      axios.get('test-results/' + id).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.modelScore = response.data
            break
          case 404:
            break
          default:
            break
        }
      })
    },

    updateScoreAttendance (bookingId) {
      this.$prompt('Nhập số điểm chuyên cần muốn chỉnh sửa', 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(({ value }) => {
        this.updateScoreAttendanceAction(bookingId, value)
      }).catch(() => {
      })
    },
    updateScoreAttendanceAction (bookingId, value) {
      let data = {
        score_attendance: value
      }
      axios.post('class-users/update-score-attendance/' + bookingId, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    trainingSystem (value) {
      if (value.toLowerCase().includes('liên thông')) {
        return 'Liên Thông'
      }
      if (value.toLowerCase().includes('văn bằng 2')) {
        return 'Văn Bằng 2'
      }
      return 'Chính Quy'
    },
    schoolLevel (value, value2) {
      if (value.toLowerCase().includes('trung cấp')) {
        return 'TRUNG CẤP'
      }
      if (!value.toLowerCase().includes('trung cấp') && !value.toLowerCase().includes('cao đẳng')) {
        if (value2.toLowerCase().includes('trung cấp')) {
          return 'TRUNG CẤP'
        }
        if (value2.toLowerCase().includes('cao đẳng')) {
          return 'CAO ĐẲNG'
        }
      }
      return 'CAO ĐẲNG'
    },
    formatPoint (number) {
      let point = parseFloat(number)
      if (isNaN(point)) {
        return ''
      }
      return Math.round(number * 10) / 10
    },
    exchangeAppellation (value) {
      let point = parseFloat(value)
      if (isNaN(point)) {
        return ''
      }
      if (point >= 9 && point <= 10) {
        return 'Xuất sắc'
      }
      if (point >= 8 && point < 9) {
        return 'Giỏi'
      }
      if (point >= 7 && point < 8) {
        return 'Khá'
      }
      if (point >= 6 && point < 7) {
        return 'Trung Bình'
      }
      if (point >= 5 && point < 6) {
        return 'Yếu'
      }
      if (point < 5) {
        return 'Không Đạt'
      }
    },
    exchangeLetterPoint (value) {
      let point = parseFloat(value)
      if (isNaN(point)) {
        return ''
      }
      if (point >= 9 && point <= 10) {
        return 'A+'
      }
      if (point >= 8 && point < 9) {
        return 'A'
      }
      if (point >= 7 && point < 8) {
        return 'B+'
      }
      if (point >= 6 && point < 7) {
        return 'B'
      }
      if (point >= 5 && point < 6) {
        return 'C'
      }
      if (point < parseFloat(5)) {
        return 'D/F'
      }
    },
    exchangeFourPoint (value) {
      let point = parseFloat(value)
      if (isNaN(point)) {
        return ''
      }
      if (point >= 9 && point <= 10) {
        return '4.0'
      }
      if (point >= 8 && point < 9) {
        return '3.5'
      }
      if (point >= 7 && point < 8) {
        return '3.0'
      }
      if (point >= 6 && point < 7) {
        return '2.5'
      }
      if (point >= 5 && point < 6) {
        return '2.0'
      }
      if (point < 5) {
        return '1.0'
      }
    },
    isNumber (value) {
      if (Number.isNaN(Number.parseFloat(value))) {
        return false
      }
      return true
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  padding: 10px 5px;
  text-align: center;
  color: #000728;
}

.delivery-bill th {
  /*background: #767676;*/
  color: #000;
  padding: 10px 0px;
}

td {
  border: 1px solid #000;
}

th {
  border: 0.1px solid #000;
}

.huhu {
  text-align: left;
  padding-left: 10px;
}

.table-common {
  padding-top: 20px;
  padding-bottom: 20px;
  max-height: 580px;
  min-height: 500px;
}

.table-common table {
  height: 100%;
  min-height: 500px;
}

.print-2023 {
  margin-top: 20px;
  width: 1000px;
}

.name-school span {
  text-transform: uppercase;
  font-variant: 15px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

.name-vn span {
  text-transform: uppercase;
  font-variant: 15px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

.name-vn span.text-2 {
  text-transform: inherit;
  font-weight: bold;
}

.line-0999 {
  height: 2px;
  width: 190px;
  border-bottom: 1px solid #000;
  display: inline-block;
}
.line-09991 {
  height: 1px;
  width: 100%;
  display: inline-block;
  position: relative;
}
.line-09991::after {
  content: "";
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 65%;
    border-bottom: 1px solid #000;
}

.main-title-999 {
  font-size: 30px;
  text-transform: uppercase;
  margin-top: 30px;
  margin-bottom: 25px;
  font-weight: bold;
}

.main-info .title {
  min-width: 130px;
  display: inline-block;
  font-size: 15px;
}

.main-info .data {
  font-weight: bold;
  color: #000;
  font-size: 15px;
}

.total-score span {
  font-weight: bold;
  color: #000;
  font-size: 17px;
}

.total-score .text-2 {
  margin-left: 150px;
}

.sign-19231 .addresss {
  margin-bottom: 10px;
  font-style: italic;
  font-weight: 400;
}

.sign-19231 .name {
  text-transform: uppercase;
  color: #000;
  font-weight: bold
}

td,
th {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.table-common {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.main-title-999 {
  font-size: 25px !important;
}

.text-uppercase {
  text-transform: uppercase;
}

.no-border {
  border: none;
  width: fit-content;
}

.no-border tr,
.no-border td {
  border: none;
}
.text-left {
  text-align: left !important;
}
.name-school {
  max-width: fit-content;
  font-size: 18px;
}
.name-wrap {
  position: relative;
}
.name_vn_son {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    font-size: 18px;
}
.item-90 span {
  font-weight: bold;
    color: #000;
    font-size: 16px;
}
.text-nowrap-mod {
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-pros/ShowPrint.vue